export default __webpack_public_path__ + "static/media/permissions_admin.c683c605.svg";